import axios from 'axios'
import React from 'react'
import { CreateNewFolder } from '@material-ui/icons'
import Dropzone from 'react-dropzone'
import Message from '../Message/Message'
import { useSelector } from 'react-redux'

const MultiFilesInput = ({
  name,
  label,
  setFiles,
  filesUploading,
  setFilesUploading,
  contentTop,
  contentBottom,
  error,
  setError,
  disabled,
}) => {
  const { userInfo } = useSelector((state) => state.userLogin)

  const handleDrop = async (acceptedFiles) => {
    setError('')

    acceptedFiles.map(async (file) => {
      const formData = new FormData()
      formData.append('file', file)
      let item = { name: file.name, size: file.size }
      let maxSize = 1000 * 1000 * 100 // 100 MB

      if (file.size > maxSize) {
        setError('Files must be under 100MB')
      } else {
        setFilesUploading((filesUploading) => [...filesUploading, item])

        try {
          const config = {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${userInfo.token}`,
            },
          }

          const { data } = await axios.post('/api/file', formData, config)

          setFilesUploading(
            filesUploading.filter((item) => item.name !== file.name)
          )

          setFiles((files) => [...files, data])
        } catch (error) {
          setFilesUploading(
            filesUploading.filter((item) => item.name !== file.name)
          )

          console.error(error)
          setError(error)
        }
      }
    })
  }

  return (
    <div
      className={`p-b-16 ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`}
    >
      <label htmlFor={name}>{label}</label>
      <Dropzone onDrop={handleDrop}>
        {({ getRootProps, getInputProps, isDragActive }) => (
          <div
            {...getRootProps({
              className: `dropzone ${isDragActive ? 'hovering' : ''}`,
            })}
          >
            <div className="dropzone-outer">
              <div className="dropzone-inner">
                <input {...getInputProps()} />
                <div className="flex align-center justify-center">
                  <CreateNewFolder />

                  <p className="m-b-0 m-l-5">{contentTop}</p>
                </div>
                <p className="m-b-0 m-l-5">{contentBottom}</p>
              </div>
            </div>
          </div>
        )}
      </Dropzone>
      {error !== '' && <Message variant="danger">{error}</Message>}
    </div>
  )
}

export default MultiFilesInput
